import { OrderForm } from 'modules/Orders/types'

export const initialOrderState: OrderForm = {
  source: 'CRM',
  phone_number: '',
  full_name: '',
  apartment: '',
  floor: '',
  intercom: '',
  comments_to_courier: '',
  delivery_way: 'COURIER',
  delivery_fee: '',
  delivery_time: '',
  delivery_type: 'NAVAT',
  payment_method: null,
  payment_status: null,
  bonus_discount: '0',
  company_slug: '',
  branch_slug: null,
  cash_amount: null,
  address: undefined,
  latitude: undefined,
  longitude: undefined,
  address_id: undefined,
  comment: '',
  products: [],
  productsAmount: 0,
  productsQuantity: 0,
  selectedProducts: [],
  clientBonuses: 0,
  addressOptions: [],
  yandexAddressOption: [],
  isYandexAddress: false,
  selectedDeliverySlotIndex: null,
  seen: false,
}
